import { render } from "./EmployeeEmergencyContacts.vue?vue&type=template&id=5d28e93c&scoped=true"
import script from "./EmployeeEmergencyContacts.vue?vue&type=script&lang=js"
export * from "./EmployeeEmergencyContacts.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=5d28e93c&lang=scss&scoped=true"
import "./EmployeeEmergencyContacts.vue?vue&type=style&index=1&id=5d28e93c&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d28e93c"]])

export default __exports__